<template>
    <section
        v-if="!showThirdNext"
        class="pop-form pop-sign-log register"
        :class="options.registerClass || ''"
        :style="{ backgroundColor: bgColor }"
    >
        <div v-if="step === 1" class="step1">
            <hgroup>
                <h2
                    v-if="registerTitle"
                    v-html="formatFontSize(registerTitle, 18)"
                ></h2>
                <h3 v-if="registerSubTitle" v-html="registerSubTitle"></h3>
            </hgroup>
            <div class="pop-form-content">
                <div class="pop-form-benefits">
                    <div
                        class="benefits-title"
                        v-if="benefitsTitle"
                        v-html="benefitsTitle"
                    ></div>
                    <ul class="benefits-list">
                        <li v-if="benefitsMarket" class="item">
                            <span class="iconfont icon-checked market"></span>
                            <div class="text" v-html="benefitsMarket"></div>
                        </li>
                        <li v-if="benefitsMoney" class="item">
                            <span class="iconfont icon-checked money"></span>
                            <div class="text" v-html="benefitsMoney"></div>
                        </li>
                        <li v-if="benefitsHomes" class="item">
                            <span class="iconfont icon-checked homes"></span>
                            <div class="text" v-html="benefitsHomes"></div>
                        </li>
                    </ul>
                </div>
                <div class="pop-form-main">
                    <template v-if="showFacebook || showGoogle">
                        <ThirdBox
                            theme="broker-new"
                            :enableFb="showFacebook"
                            :enableGoogle="showGoogle"
                            :fbBtnText="$t('common:fbBtnText')"
                            :googleBtnText="$t('common:googleBtnText')"
                            @auth="authCallback"
                        >
                        </ThirdBox>
                        <p class="desc">
                            <span class="line"></span>
                            <span class="text">{{
                                $t('common:register.orUseYourEmail')
                            }}</span>
                            <span class="line"></span>
                        </p>
                    </template>
                    <v-form
                        :onSubmit="emailSubmit"
                        :onSuccess="emailSubmitSuccess"
                        :onError="emailSumbitError"
                        ref="form-step1"
                        key="step1"
                    >
                        <v-input
                            name="email"
                            type="email"
                            :placeholder="$t('common:enterEmailAddress') + '*'"
                            required
                            focus
                            clearable
                            :validateConfig="{
                                async: '/api-site/register/hasUser?account={value}',
                                'email-msg': $t(
                                    'common:validate.emailInvalid2'
                                ),
                                'async-callback': hasUserCallBack
                            }"
                            :otherOption="{ cutting: 24 }"
                            @change="emailChange"
                            @input="emailChangeWithTrack"
                        ></v-input>
                        <div :class="{'submit':true, disabled:submitDisabled}">
                            <input
                                type="submit"
                                :class="{ 'btn-disabled': step1Disabled }"
                                :value="
                                    options.submitRegister || $t('common:continue')
                                "
                                :style="options.submitRegisterStyle || {}"
                            />
                        </div>
                        
                        <div
                            v-if="options.hasVow && options.agreement"
                            class="agree-lender"
                        >
                            <label>
                                <input
                                    type="checkbox"
                                    checked
                                    name="agree"
                                    value="true"
                                />
                                <span class="iconfont icon-checked"></span>
                                <span
                                    class="agreement-txt"
                                    v-html="options.agreement"
                                ></span>
                            </label>
                        </div>
                        <p
                            v-show="registerErrorShow || thirdPartErrorShow"
                            class="mg-error"
                        >
                            {{ registerErrorMsg || thirdPartErrorMsg }}
                        </p>
                    </v-form>
                    <p class="sign-in">
                        {{ $t('common:register.oldHere') }}
                        <a
                            class="mg-color"
                            @click.prevent="changeType('login')"
                            rel="noopener noreferrer"
                        >{{ $t('common:goLogin') }}</a
                        >
                    </p>
                </div>
            </div>
        </div>
        <div v-if="step === 2" class="step2">
            <hgroup>
                <h2 v-if="registerTitleTwo" v-html="registerTitleTwo"></h2>
                <h3
                    v-if="registerSubTitleTwo"
                    v-html="registerSubTitleTwo"
                ></h3>
            </hgroup>
            <div class="pop-form-content">
                <div class="pop-form-benefits">
                    <div
                        class="benefits-title"
                        v-if="benefitsTitle"
                        v-html="benefitsTitle"
                    ></div>
                    <ul class="benefits-list">
                        <li v-if="benefitsMarket" class="item">
                            <span class="iconfont icon-checked market"></span>
                            <div class="text" v-html="benefitsMarket"></div>
                        </li>
                        <li v-if="benefitsMoney" class="item">
                            <span class="iconfont icon-checked money"></span>
                            <div class="text" v-html="benefitsMoney"></div>
                        </li>
                        <li v-if="benefitsHomes" class="item">
                            <span class="iconfont icon-checked homes"></span>
                            <div class="text" v-html="benefitsHomes"></div>
                        </li>
                    </ul>
                </div>
                <div class="pop-form-main">
                    <v-form
                        :onSubmit="registerSubmit"
                        :onSuccess="registerSubmitSuccess"
                        :onError="registerSumbitError"
                        ref="form-step2"
                        key="step2"
                    >
                        <template v-if="options.nameType === 2">
                            <v-input
                                v-if="options.nameType === 2"
                                name="firstName"
                                type="text"
                                :placeholder="
                                    $t('common:firstName') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                                focus
                                clearable
                                @input="nameChange"
                            ></v-input>
                            <v-input
                                v-if="options.nameType === 2"
                                name="lastName"
                                type="text"
                                clearable
                                :placeholder="
                                    $t('common:lastName') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                                @input="nameChange"
                            ></v-input>
                        </template>
                        <template v-else-if="options.nameType === 3">
                            <v-input
                                class="half"
                                name="prefix"
                                type="text"
                                clearable
                                :placeholder="
                                    $t('common:prefix') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                                focus
                            ></v-input>
                            <v-input
                                class="half"
                                name="firstName"
                                type="text"
                                clearable
                                :placeholder="
                                    $t('common:firstName') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                            <v-input
                                class="half"
                                name="lastName"
                                type="text"
                                clearable
                                :placeholder="
                                    $t('common:lastName') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                            <v-input
                                class="half"
                                name="suffix"
                                type="text"
                                clearable
                                :placeholder="
                                    $t('common:suffix') +
                                        (options.nameRequired ? '*' : '')
                                "
                                :required="options.nameRequired || false"
                                :maxlength="30"
                            ></v-input>
                        </template>
                        <v-input
                            v-else
                            name="fullname"
                            type="text"
                            clearable
                            :placeholder="
                                $t('common:fullName') +
                                    (options.nameRequired ? '*' : '')
                            "
                            :required="options.nameRequired || false"
                            :maxlength="30"
                            focus
                            @input="nameChange"
                        ></v-input>
                        <v-input
                            v-if="options.note"
                            name="note"
                            type="text"
                            clearable
                            :placeholder="options.note.text"
                            :required="options.note.required || false"
                            :maxlength="options.note.length || 50"
                        ></v-input>
                        <v-input
                            name="phone"
                            type="tel"
                            clearable
                            :placeholder="
                                $t('common:register.passwordPlaceholder1', {
                                    infix: phoneRequired ? '*' : ''
                                })
                            "
                            :required="phoneRequired"
                            :validateConfig="{
                                async: '/api-site/phoneValidate?phoneNumber={value}',
                                'tel-msg': $t('common:validate.phoneInvalid2')
                            }"
                            @input="phoneChange"
                        ></v-input>
                        <div
                            v-if="!!phoneDesciption"
                            v-html="phoneDesciption"
                        ></div>
                        <disclaimer :disclaimerUniqId="disclaimerUniqId" @updateChecked="updateChecked" class="pop-register-disclaimer" color="#505050" :bgColor="bgColor" :btnText="options.submitRegisterTwo || $t('common:submit')" />
                        <div :class="{'submit':true, disabled:disclaimerSubmitDisabled}" :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''">
                            <input
                                type="submit"
                                :class="{ 'btn-disabled': step2Disabled }"
                                :value="
                                    options.submitRegisterTwo || $t('common:submit')
                                "
                                :style="options.submitRegisterStyleTwo || {}"
                            /></div>
                        <p
                            v-show="registerErrorShow || thirdPartErrorShow"
                            class="mg-error"
                        >
                            {{ registerErrorMsg || thirdPartErrorMsg }}
                        </p>
                    </v-form>
                </div>
            </div>
        </div>
    </section>
    <third-register-next
        ref="third-next"
        v-else
        :options="options"
        :fullname="
            authData.fullname ||
                (authData.firstName
                    ? authData.firstName + ' ' + authData.lastName || ''
                    : authData.lastName || '')
        "
        :email="authData.email"
        :phoneRequired="phoneRequired"
        :thirdPartErrorShow="thirdPartErrorShow"
        :thirdPartErrorMsg="thirdPartErrorMsg"
        :thirdRegisterSubmit="thirdRegisterSubmit"
        :thirdRegisterSubmitSuccess="thirdRegisterSubmitSuccess"
        :thirdRegisterSumbitError="thirdRegisterSumbitError"
    ></third-register-next>
</template>

<script>
import register from '../register.js';
import thirdPart from '../third-part.js';
import thirdRegisterNextVue from './third-register-next.vue';
import { twoColumn } from '../set-gtm-data-mixins';

export default {
    mixins: [register, thirdPart, twoColumn],
    data: function() {
        return {
            emailVal: '',
            nameVal: '',
            phoneVal: ''
        };
    },
    computed: {
        step1Disabled() {
            return !this.emailVal;
        },
        step2Disabled() {
            let flag = false;
            if (this.options.nameRequired && !this.nameVal) {
                flag = true;
            }
            if (this.phoneRequired && !this.phoneVal) {
                flag = true;
            }
            return flag;
        },
        benefitsTitle() {
            if (this.options.benefitsTitle === undefined) {
                return this.$t('common:register.registrationBenefit');
            } else {
                return this.options.benefitsTitle;
            }
        },
        benefitsMarket() {
            if (this.options.benefitsMarket === undefined) {
                return this.$t('common:register.benefit1');
            } else {
                return this.options.benefitsMarket;
            }
        },
        benefitsMoney() {
            if (this.options.benefitsMoney === undefined) {
                return this.$t('common:register.benefit2');
            } else {
                return this.options.benefitsMoney;
            }
        },
        benefitsHomes() {
            if (this.options.benefitsHomes === undefined) {
                return this.$t('common:register.benefit3');
            } else {
                return this.options.benefitsHomes;
            }
        }
    },
    methods: {
        emailChange(name, value) {
            this.emailVal = value;
        },
        emailChangeWithTrack(name, value) {
            this.emailChange(name, value);
            this.onTrackEmail(this.regType.email);
        },
        nameChange(name, value) {
            if (name === 'firstName') {
                this.firstName = value;
                this.onTrackName(this.regType.name);
            }
            if (name === 'lastName') {
                this.lastName = value;
            }
            if (name === 'fullname') {
                this.nameVal = value;
                this.onTrackName(this.regType.name);
            } else {
                this.nameVal =
                    this.firstName +
                    (this.firstName ? ' ' : '') +
                    this.lastName;
            }
        },
        phoneChange(name, value) {
            this.phoneVal = value;
            this.onTrackPhone(this.regType.phone);
        }
    },
    components: {
        'third-register-next': thirdRegisterNextVue
    }
};
</script>
